var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export function isCategory(category) {
    return (Boolean(category) && ['commercial', 'private'].indexOf(category) !== -1);
}
export function convertConfigurationToV2(initialConfiguration) {
    const _a = initialConfiguration, { tenant: category } = _a, configuration = __rest(_a, ["tenant"]);
    if (isCategory(category)) {
        return Object.assign(Object.assign({}, configuration), { category });
    }
    throw new Error('Tenant is neither private nor commercial');
}
